import React from 'react'
import MemberProfile from '../MemberProfile/MemberProfile'

const MemberProfileHCC = () => {
    return (
        <MemberProfile />
    )
}

export default MemberProfileHCC